import { Person } from "@shapeable/gesda-types";
import { useEditions } from "./use-editions";
import { maxBy, toNumber, toString } from 'lodash';
import { useCurrentEdition } from "./use-current-edition";

export const useCurrentEditionMembers = (committeeMembers: Person[]) => {
  const currentYear = new Date().getFullYear();
  const currentEdition = useCurrentEdition();
  return committeeMembers.filter(member => member.badge?.includes(toString(currentEdition?.name || currentYear)));
}